<div *ngIf="loading">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div> 
 
   <mat-card class="row m-1" *ngIf="!selectedBook"> 
      <mat-form-field *ngIf="user.profile ==='admin'">
        <mat-label>Editore</mat-label>
        <mat-select [(ngModel)]="editoreFilter"  (ngModelChange)="
            getListaLanci(filters[0].selected, filters[1].selected, filters[2].selected)
          ">
            <mat-option
              *ngFor="let editore of editori"
              [value]="editore.cod"
            >
              {{ editore.descrizione }}
            </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field *ngFor="let select of filters" class="col-1">
        <mat-label>{{ select.filterName }}</mat-label>
        <mat-select
          [(ngModel)]="select.selected"
          (ngModelChange)="
            getListaLanci(filters[0].selected, filters[1].selected, filters[2].selected)
          "
        >
          <mat-option
            *ngFor="let selectVal of select.filterData"
            [value]="selectVal.id"
          >
            {{ selectVal.value }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </mat-card>
<div *ngIf="!loading && !selectedBook">
  <mat-card
    class="book"
    *ngFor="let book of books"
  >
    <div
      class="row"
      [id]="book.oid"
    >
      <div class="col-2">
        <app-image-view
          [ean]="book.ean"
          [type]="'mini'"
        ></app-image-view>
      </div>
      <div class="col-9">
         
        <h2>{{ book.titolo | uppercase }} </h2>
         <span style="color:cornflowerblue;" *ngIf="user.profile ==='admin'">{{ book.editore | uppercase }}</span>
        <h3>[ISBN]: {{ book.ean }}</h3>
       
        <p>
          Autore: {{ book.autore | uppercase }}<br />
          Collana: {{ book.collana }}<br />
          Argomento: {{ book.argomento }} <br />
          Giro : {{ book.numero_giro }}/{{ book.anno_giro
          }}<br />
          Data di commercializzazione :
          {{ formatData(book.data_pubblicazione) }} 
          <br />
           <app-giacenza-counter [book]="book"></app-giacenza-counter>
        </p>
      </div>

      <div class="col-1">
        <div class="ribbon-content">
          <div
            class="ribbon {{ returnStatus(book) }} px-5"
            *ngIf="isNovita(book) && book.ristampa !== '2'"
          >
            <span class="uppercase">{{ returnStatus(book) }}</span>
          </div>
          <div
            class="ribbon ristampa px-5"
            *ngIf="book.ristampa === '2'"
          >
            <span class="uppercase">Ristampa</span>
          </div>
        </div>
      </div>
    </div>
    <mat-card-actions align="end">
      <button
        mat-raised-button
        color="primary"
        (click)="view( book)"
      >
       Visualizza
      </button>
       
    </mat-card-actions> 
  </mat-card>
</div>
<div *ngIf="selectedBook"> 
<book-form
        (OnClickNovita)="closeBookForm()"
        [oid]="selectedBook.oid"
        [consegnatoMagazzino]="selectedBook.flag_giacenza === '1'"
        [viewOnly]="true"
      ></book-form>